import { GlowShadow } from '../../../../Components/GlowShadow'
import styled, { keyframes, css } from "styled-components";

const scroll = keyframes`
  from { transform: translateX(0); }
  to   { transform: translateX(-50%); } /* A + B => -50% fecha o loop */
`;

const Wrap = styled.div`
  position: relative;
  width: 70%;
  overflow: hidden;
  padding: var(--padY, 24px) 0;
  padding-bottom: 73px;

  -webkit-mask-image: linear-gradient(to right, transparent 0%, black 8%, black 92%, transparent 100%);
  mask-image: linear-gradient(to right, transparent 0%, black 8%, black 92%, transparent 100%);
`;

const Track = styled.div`
  display: flex;
  gap: var(--gap, 72px);
  align-items: center;
  width: max-content;
  animation: ${scroll} linear infinite;
  animation-duration: var(--duration, 28s);

  /* pausa no hover, se quiser */
  ${({ $pauseOnHover }) =>
    $pauseOnHover &&
    css`
      ${Wrap}:hover & { animation-play-state: paused; }
    `}
`;

const Lane = styled.div`
  display: flex;
  gap: var(--gap, 72px);
  align-items: center;
`;

const Logo = styled.img`
  height: var(--logoH, 44px);
  width: auto;
  opacity: .8;
  filter: grayscale(100%);
  transition: opacity .2s ease, filter .2s ease, transform .2s ease;
  user-select: none;
  pointer-events: auto;

  &:hover {
    opacity: 1;
    filter: grayscale(0%);
    transform: translateY(-1px);
  }
`;

export function ClientsMarquee({
  items = [],              // [{src, alt}]
  height = 44,             // altura do logo
  gap = 72,                // espaço entre logos
  duration = 28,           // segundos por ciclo
  padY = 24,               // padding vertical do container
  pauseOnHover = true,     // pausa quando passa o mouse
  glowColor = "rgba(76,137,255,.55)", // cor do brilho inferior
  shadowHeight = 56,       // altura da “névoa” na base
  direction = "rtl",       // "rtl" (direita→esquerda) | "ltr"
}) {
  // inverter a direção se precisar
  const dirStyle =
    direction === "ltr"
      ? { transform: "scaleX(-1)" } // espelha o trilho…
      : undefined;

  return (
    <Wrap
      style={{
        "--padY": `${padY}px`,
        "--glow": glowColor,
        "--shadowH": `${shadowHeight}px`,
      }}
    >
      <Track
        $pauseOnHover={pauseOnHover}
        style={{ "--gap": `${gap}px`, "--duration": `${duration}s`, ...(direction === "ltr" ? { direction: "rtl" } : {}) }}
      >
        <Lane style={dirStyle}>
          {items.map((it, i) => (
            <Logo key={`a-${i}`} src={it.src} alt={it.alt || `logo-${i}`} style={{ "--logoH": `${height}px` }} />
          ))}
        </Lane>
        <Lane style={dirStyle}>
          {items.map((it, i) => (
            <Logo key={`b-${i}`} src={it.src} alt={it.alt || `logo-${i}`} style={{ "--logoH": `${height}px` }} />
          ))}
        </Lane>
      </Track>
      <GlowShadow />
    </Wrap>
  );
}
